module.exports = __webpack_public_path__ + "bc2d02a1b4cddc96a34ee309f84e5587.svg";